<template>
<!-- 产品管理 主页 -->
  <div>
    <navigation-bar></navigation-bar>
    <div class="main">
      <el-row>
        <!-- 左侧导航栏 -->
        <el-col :span="4">
          <div class="sidebar">
            <div class="sidebar_title">产品管理</div>
            <div class="sidebar_item" :class='{ active:index === number}' v-for="(item, index) in productList" :key="index" @click="change(index)">
              {{item.name}}
            </div>
          </div>
        </el-col>
        <!-- 内容 -->
        <el-col :span="16">
          <div class="content">
            <!-- banner -->
            <div class="banner">
              <img src="../../../assets/channel/banner_产品.png" alt="">
              <div class="ban_content">
                <div class="ban_title">{{bannerContent.name}}</div>
						    <div class="ban_pro">{{bannerContent.description}}</div>
						    <div class="ban_link" @click="signupOnline(bannerContent)">在线签约</div>
              </div>
            </div>
            <!-- download area -->
            <div class="download_area">
              <el-row>
                <el-col :span="8" v-for="(item,index) in childList" :key="index">
                  <div class="down_item">
                    <div class="down_icon">
                      <img :src="item.image" alt="">
                    </div>
                    <div class="down_text">
                      <div class="title">{{item.name}}</div>
						          <div class="description">nihao你好啊你好好计划订单</div>
                    </div>
                    <div class="down_button" @click="download(item)">下载</div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- service content -->
            <div class="service_content">
              <span>服务内容</span>
              <div class="service_main">
                <div class="service_item" v-for="(item,index) in serviceList" :key="index">
                  <div class="icon">
					        	<img :src="item.image" alt="">
					        </div>
					        <div class="text">
					        	<div class="title">{{item.name}}</div>
					        	<div class="description">{{item.value}}</div>
					        </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- dialog -->
      <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="30%">
        <div>
          <div class="picture">
            <img :src="picture" alt="">
          </div>
          <div class="button">
            <a :href="iosLink" target="_blank" rel="noopener noreferrer">
              <img src="../../../assets/console/cpgl/ios.png" alt="">IOS版下载
            </a>
          </div>
          <div class="button">
            <a :href="androidLink" target="_blank" rel="noopener noreferrer">
              <img src="../../../assets/console/cpgl/android.png" alt="">Android版下载
            </a>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
    import { queryProductByType, queryAttributeValueByProductId, queryProductByParentId, createDownloadProductQRCode } from '@/api/channel/product.js'
    import NavigationBar from '../../../components/console/navigationBar.vue'
    export default {
        components: {
            NavigationBar
        },
        data() {
            return {
              productList: [],
              number: 1,
              bannerContent: {},
              id: 0,
              childList: [],
              serviceList: [],
              //dialog
              dialogVisible: false,
              iosLink: '',
              androidLink: '',
              picture: '',
            }
        },
        created() {
          this.getData();
        },
        watch: {
          picture(val) {
            this.picture = val;
          }
        },
        methods: {
          getData() {
            let type = 0;
            queryProductByType(type).then(res => {
                this.productList = res.data.list;
                this.change(0);
            })
          },
          change(index) {
            this.number = index;
            this.bannerContent = this.productList[index];
            this.id = this.productList[index].id;
            this.getProductDetail();
            this.getChildProduct();
          },
          //获取产品详情
          getProductDetail() {
            let id = this.id;
            queryAttributeValueByProductId(id).then(res=> {
              let list = res.data.list;
              list.shift();
              this.serviceList = list;
            })
          },
          //获取子商品
          getChildProduct() {
            let id = this.id;
            queryProductByParentId(id).then(res=> {
              this.childList = res.data.list;
            })
          },
          //在线签约
          signupOnline(item) {
            this.$router.push({path: '/onlineSignup', query: {id: item.id}})
          },
          //app下载
          download(item) {
            if(item.name == 'APP端服务') {
              this.dialogVisible = true;
              let id = item.id;
              let router = '/mobileDownload'
              //二维码
              createDownloadProductQRCode(id,router).then(res => {
                this.picture = res.data;
              })
              //根据id查询下载链接
              queryAttributeValueByProductId(id).then(res => {
                // console.log(res.data.list);
                let arr = [];
                res.data.list.forEach(e => {
                  if(e.flag == 'download') {
                    arr.push(e);
                  }
                });
                for(let i = 0; i < arr.length; i++) {
                  if(arr[i].name == "iOS") {
                    this.iosLink = arr[i].value;
                  } else if(arr[i].name == "Android") {
                    this.androidLink = arr[i].value;
                  }
                }
              })
            }
          },
        }
    }
</script>

<style lang="scss" scoped="scoped">
    .main {
        margin-top: 80px;
        .sidebar {
          width: 80%;
          height: 1200px;
          color: #4F4F4F;
          border-right: 1px solid #E5E5E5;
          .sidebar_title {
              height: 79px;
              border-bottom: 1px solid #E5E5E5;
              text-align: center;
              line-height: 79px;
          }
          .sidebar_item {
            height: 47px;
            padding-left: 10%;
            font-size: 14px;    
            // text-align: center;
            line-height: 47px;
          }
          .active {
            background-color: #F8F9FF;
            color: #537EEE;
            border-right: 4px solid #537EEE;
          }
          .sidebar_item:hover {
            cursor: pointer;
            background-color: #F8F9FF;
            color: #537EEE;
          }
      }
      .content {
        .banner {
          position: relative;
          height: 340px;
          img {
            position: relative;
            width: 100%;
            height: 100%;
          }
          .ban_content {
              position: absolute;
              top: 20%;
              left: 5%;
              z-index: 2;
              padding-right: 5%;
              .ban_title {
                margin-bottom: 10px;
                font-size: 40px;
                font-weight: 700;
                color: #3B3B3B;
              }
              .ban_pro {
                font-size: 16px;
                color: rgb(38, 38, 38);
              }
              .ban_link {
                width: 160px;
                height: 38px;
                margin-top: 40px;
                background-color: rgba(87, 131, 238, 1);
                font-size: 16px;
                color: #fff;
                text-align: center;
                line-height: 38px;
                border-radius: 4px;
              }
              .ban_link:hover {
                cursor: pointer;
              }
          }
        }
        .download_area {
          height: 155px;
          margin: 80px 0;
          .down_item {
            position: relative;
            display: flex;
            width: 90%;
            height: 153px;
            margin-left: 5%;
            border: 1px solid #E5E5E5;
            .down_icon img {
              width: 140px;
              height: 140px;
            }
            .down_text {
              .title {
                margin: 30px 0 5px;
                color: #515151;
                font-weight: 700;
              }
              .description{
                font-size: 10px;
                color: #7F7F7F;
                line-height: 20px;
              }
            }
            .down_button {
              position: absolute;
              right: 0;
              bottom: 0;
              width: 30%;
              height: 26px;
              background-color: #5984EC;
              font-size: 10px;
              color: #fff;
              text-align: center;
              line-height: 26px;
            }
            .down_button:hover {
              cursor: pointer;
            }
          }
          .down_item:hover {
            bottom: 5px;
            transition: all ease .2s;
            box-shadow: 0px 6px 12px 2px #ccc;
          }
        }
        .service_content {
          span {
            color: #4F4F4F;
          }
          .service_main {
            overflow: hidden;
            .service_item {
              float: left;
              display: flex;
              align-items: center;
              width: 33%;
              height: 155px;
              // border: 1px solid blue;
              .icon {
                width: 66px;
                height: 66px;
                margin-left: 10%;
                // border: 1px solid blue;
                img {
                  width: 66px;
                }
              }
              .text {
                margin-left: 5%;
                .title {
                  margin-bottom: 5px;
                  font-weight: 700;
                  color: #515151;
                }
                .description {
                  font-size: 10px;
                  color: #7F7F7F;
                  line-height: 20px;
                }
              }
            }
          }
        }
      }
      .el-dialog {
        .picture {
          display: flex;
          justify-content: center;
          margin-bottom: 20px;
          img {
            width: 242px;
            height: 242px;
          }
        }
        .button {
          margin-bottom: 20px;
          text-align: center;
          a {
            position: relative;
            display: inline-block;
            width: 40%;
            height: 32px;
            background-color: #5984EC;
            color: #fff;
            text-decoration: none;
            line-height: 32px;
            img {
              position: absolute;
              top: 2px;
              left: 10px;
              width: 25px;
              height: 25px;
            }
          }
        }
      }
    }
    
</style>